import { render } from "./Add.vue?vue&type=template&id=b07a1148"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/DocumentTemplates/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b07a1148"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b07a1148', __exports__)) {
    api.reload('b07a1148', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=b07a1148", () => {
    api.rerender('b07a1148', render)
  })

}


export default __exports__